import { lazy, type ComponentType } from 'react'
import styled from '@emotion/styled'

// lo stesso blu dei link del Control Panel (colorLink del tema)
const LINK_COLOR = '#1890ff'

const PlainText = ({ children }: { children: string }) => <p>{children}</p>

// Se il chunk del parser non si carica il testo si mostra comunque, senza formattazione
const SafeMarkdownContent = lazy<ComponentType<{ children: string }>>(() =>
  import('./SafeMarkdownContent').catch(() => ({ default: PlainText }))
)

/**
 * Testo markdown ristretto (grassetto, corsivo, barrato, link, elenchi) senza HTML.
 * Va in un Suspense: finché il parser non è caricato non mostra nulla, così non compare la sintassi grezza
 */
export const SafeMarkdown = ({ children, className }: { children: string; className?: string }) => (
  <Root className={className}>
    <SafeMarkdownContent>{children}</SafeMarkdownContent>
  </Root>
)

const Root = styled.div`
  overflow-wrap: anywhere;
  p,
  ul,
  ol {
    margin: 0;
  }
  p {
    white-space: pre-line;
  }
  & > * + *,
  li > * + * {
    margin-top: 0.5em;
  }
  ul,
  ol {
    padding-left: 1.25em;
  }
  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }
  // il default (bolder) su un testo light darebbe un peso normale
  strong {
    font-weight: 700;
  }
  a {
    color: ${LINK_COLOR};
    text-decoration: underline;
  }
  code {
    font-family: monospace;
  }
`
